(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/ticket-skin-sunfeather.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/ticket-skin-sunfeather.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
  memo
} = React;
const {
  Image
} = svs.content.image_v2;
const {
  sunfeather
} = svs.tickets.play.utils.animations;
const ImgWrapper = memo(_ref => {
  let {
    image,
    number
  } = _ref;
  return React.createElement(Image, {
    cssSelectors: "ticket-skin-shadow",
    image: _objectSpread(_objectSpread({}, image), {}, {
      altText: "Lott-".concat(number)
    })
  });
});
function useSunfeatherAnimation(animation) {
  const ref = useRef(null);
  const intro = useMemo(() => (sunfeather.intro[animation] || sunfeather.intro.default).bind(null, ref), [ref, animation]);
  const select = useMemo(() => (sunfeather.select[animation] || sunfeather.select.default).bind(null, ref), [ref, animation]);
  const mouseEnter = useMemo(() => (sunfeather.mouseEnter[animation] || sunfeather.mouseEnter.default).bind(null, ref), [ref, animation]);
  const sibblingEnter = useMemo(() => (sunfeather.sibblingEnter[animation] || sunfeather.sibblingEnter.default).bind(null, ref), [ref, animation]);
  const mouseLeave = useMemo(() => (sunfeather.mouseLeave[animation] || sunfeather.mouseLeave.default).bind(null, ref), [ref, animation]);
  const outro = useMemo(() => (sunfeather.outro[animation] || sunfeather.outro.default).bind(null, ref), [ref, animation]);
  return {
    ref,
    intro,
    select,
    mouseEnter,
    sibblingEnter,
    mouseLeave,
    outro
  };
}
setGlobal('svs.tickets.play.components.TicketSkinSunfeather', memo(_ref2 => {
  let {
    gamePayed,
    hasFocus,
    number,
    handleGamePay,
    onHandleNumberChanged,
    numberOfTickets = 31,
    image,
    appTimeline = gsap.timeline(),
    chosen,
    onMouseEnter,
    onMouseLeave,
    hoverState,
    animation = ''
  } = _ref2;
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);
  const {
    ref: ticketSkinRef,
    intro,
    select,
    mouseEnter,
    sibblingEnter,
    mouseLeave,
    outro
  } = useSunfeatherAnimation(animation);
  useEffect(() => {
    if (imgRef.current) {
      setLoaded(true);
    }
  }, [imgRef.current]);

  useEffect(() => {
    if (loaded) {
      const unmount = intro(appTimeline, number);
      if (chosen) {
        select(appTimeline);
      }
      return () => {
        unmount && unmount();
      };
    }
  }, [loaded, number]);

  useEffect(() => {
    if (appTimeline.time() >= (appTimeline.labels.gameReady || 0)) {
      if (chosen) {
        const tl = select();
        return () => {
          tl && tl.kill(ticketSkinRef.current);
        };
      }
      appTimeline.progress(1, false);
      mouseLeave(number);
    }
  }, [chosen]);

  useEffect(() => {
    if (!chosen && !gamePayed && loaded && appTimeline.time() >= (appTimeline.labels.gameReady || 0)) {
      if (hoverState === 0) {
        mouseEnter(number);
      } else if (hoverState) {
        sibblingEnter(hoverState, number);
      } else {
        mouseLeave(number);
      }
    }
  }, [hoverState, loaded, number]);

  useEffect(() => {
    if (gamePayed) {
      outro();
    }
  }, [gamePayed]);
  const onClick = useCallback(() => {
    if (!gamePayed && chosen) {
      handleGamePay && handleGamePay();
    } else {
      onHandleNumberChanged(number);
    }
  }, [gamePayed, chosen, handleGamePay, onHandleNumberChanged, number]);
  const onHoverEnter = useCallback(() => !chosen && onMouseEnter(number), [chosen, onMouseEnter, number]);
  const onHoverLeave = useCallback(() => !chosen && onMouseLeave(number), [chosen, onMouseLeave, number]);
  return React.createElement("div", {
    className: "".concat(loaded ? 'image-loaded' : '', " ticket-skin-wrapper relative"),
    "data-ticket-number": number,
    onClick: onClick,
    ref: ticketSkinRef,
    style: {
      transform: 'scale(0)',
      zIndex: numberOfTickets - number
    }
  }, React.createElement("div", {
    className: "ticket-number absolute"
  }, number), React.createElement("div", {
    className: "".concat(hasFocus ? 'ticket-skin-focus' : ''),
    onMouseEnter: onHoverEnter,
    onMouseLeave: onHoverLeave,
    ref: imgRef
  }, React.createElement(ImgWrapper, {
    image: image,
    number: number
  })));
}));

 })(window);